import React from "react";
import { useState } from "react";
import './Projects.css'
import Projectsimage from '../../assets/Projects/ongoingProjects.png'
import ongoingproject1 from '../../assets/Projects/ongoingproject1.png'
import ongoingproject2 from '../../assets/Projects/ongoingproject2.png'
import ongoingproject3 from '../../assets/Projects/ongoingproject3.png'
import caseStudy1 from '../../assets/Projects/Riyadh Metro Project (Line 6 Stations).png'
import caseStudy2 from '../../assets/Projects/NEOM Sindalah Island.png'
import caseStudy3 from '../../assets/Projects/Fadhili Gas Plant Pipeline.png'
import tustedlogo1 from '../../assets/Projects/tustedlogo1.png'
import tustedlogo2 from '../../assets/Projects/tustedlogo2.png'
import tustedlogo3 from '../../assets/Projects/tustedlogo3.png'
import tustedlogo4 from '../../assets/Projects/tustedlogo4.png'
import tustedlogo5 from '../../assets/Projects/tustedlogo5.png'
import tustedlogo6 from '../../assets/Projects/tustedlogo6.png'
import tustedlogo7 from '../../assets/Projects/tustedlogo7.png'
import tustedlogo8 from '../../assets/Projects/tustedlogo8.png'
import tustedlogo9 from '../../assets/Projects/tustedlogo9.png'
import tustedlogo10 from '../../assets/Projects/tustedlogo10.png'
import tustedlogo11 from '../../assets/Projects/tustedlogo11.png'
import tustedlogo12 from '../../assets/Projects/tustedlogo12.png'
import tustedlogo13 from '../../assets/Projects/tustedlogo13.png'
import tustedlogo14 from '../../assets/Projects/tustedlogo14.png'
import completedproject1 from '../../assets/Projects/completedproject1.png'
import completedproject2 from '../../assets/Projects/completedproject2.png'
import completedproject3 from '../../assets/Projects/completedproject3.png'
import completedproject4 from '../../assets/Projects/completedproject4.png'
import completedproject5 from '../../assets/Projects/completedproject5.png'
import completedproject6 from '../../assets/Projects/completedproject6.png'
import completedproject7 from '../../assets/Projects/completedproject7.png'
import completedproject8 from '../../assets/Projects/completedproject8.png'
import completedproject9 from '../../assets/Projects/completedproject9.png'
import completedproject10 from '../../assets/Projects/completedproject10.png'


const ongoingProjects = [
    {
        id :1,
        image : ongoingproject1,
        title : 'Gas Compression Replacement – Shedgum Plant',
        status : 'Ongoing',
        client : 'Saudi Aramco (via AHC)',
        contractor : 'A HAK Company'
    },
    {
        id : 2,
        image : ongoingproject2,
        title : 'FADHILI GAS PLANT PIPELINE PROJECT',
        status : 'Ongoing',
        client : 'A HAK COMPANY',
        contractor : 'ARAMCO'
    },
    {
        id : 3,
        image : ongoingproject3,
        title : 'Haram Mecca Project',
        status : 'Ongoing',
        client : 'Saudi Bin Laden Group',
        contractor : 'Seele Company'
    }
]

const tustedLogos = [
  tustedlogo1,tustedlogo2,
  tustedlogo3,tustedlogo4,
  tustedlogo5,tustedlogo6,
  tustedlogo7,tustedlogo8,
  tustedlogo9,tustedlogo10,
  tustedlogo11,tustedlogo12,
  tustedlogo13,tustedlogo14,

]


const completedProjects = [
    {
        id :1,
        image : completedproject10,
        title : 'Riyadh Metro Project (Line 6 Stations)',
        status : 'Completed',
        client : 'Royal Commission',
        contractor : 'Al Ghurair'
    },
    {
        id : 2,
        image : completedproject9,
        title : 'NEOM Sindalah Island',
        status : 'Completed',
        client : 'NEOM',
        contractor : 'Nova Composites'
    },
    {
        id : 3,
        image : completedproject8,
        title : 'Fadhili Gas Plant Pipeline',
        status : 'Completed',
        client : 'Aramco',
        contractor : 'Arkad'
    },
    {
        id : 4,
        image : completedproject7,
        title : 'Jizan Refinery & Terminal',
        status : 'Completed',
        client : 'Aramco',
        contractor : 'CCC'
    },
    {
        id : 5,
        image : completedproject6,
        title : 'King Abdulaziz Center (Ithra)',
        status : 'Completed',
        client : 'Aramco',
        contractor : 'Saudi Oger'
    },
    {
        id : 6,
        image : completedproject5,
        title : 'KAPSARC',
        status : 'Completed',
        client : 'Aramco',
        contractor : 'Drake & Scull'
    },
    {
        id : 7,
        image : completedproject4,
        title : 'Shuqaiq Steam Power Plant',
        status : 'Completed',
        client : 'SEC',
        contractor : 'Hyundai Heavy Industries'
    },
    {
        id : 8,
        image : completedproject3,
        title : 'Princess Noura University',
        status : 'Completed',
        client : 'Saudi Oger',
        contractor : 'Riyadh'
    },
    {
        id : 9,
        image : completedproject2,
        title : 'King Abdullah Financial District (KAFD)',
        status : 'Completed',
        client : 'PIF',
        contractor : 'MAC'
    },
    {
        id : 10,
        image : completedproject1,
        title : 'Marafiq Power Plant',
        status : 'Completed',
        client : 'Marafiq',
        contractor : 'Jubail'
    }
]


const Projects = () =>{

    const [showOngoing, setShowOngoing] = useState(true);

    const projectsToShow = showOngoing ? ongoingProjects : completedProjects


    const arrayOfProjectsData = projectsToShow.map(project =>
       <div className="project-card" key={project.id}>
        <img
            src={project.image}
            alt="project"
            className="ongoing-project-image"
        />

        <div className="title-container">
            <h1 className="project-title">{project.title}</h1>
            <div className="ongoing-project-status">
                {/* <p className="status">{project.status}</p> */}
                <p
                className="status"
                style={{
                    backgroundColor: project.status === "Ongoing" ? "#FFEDD5" : "#DCFCE7",
                    color : project.status === "Ongoing" ? "#9A3412" : "#166534",
                }}
                >
                {project.status}
                </p>

            </div>
        </div>

        <div className="project-client-details">
            <p className="client-name"><span>Client:</span> {project.client}</p>
            <p className="client-name"><span>Contractor:</span> {project.contractor}</p>
        </div>
        </div>
    )
    return(
        <>
        <div className="projects-image-container">
        <div className="overlay-text-container">
          <h1 className="about-main-heading">Our Projects</h1>
          <p className="about-main-description">“TAUC has been trusted to deliver critical works for energy, infrastructure, metro, and giga-projects since 2001.”</p>
        </div>
      </div>
           

            <div className="projects-button-section">
                <button className={`projects-button ${showOngoing ? 'active' : ''}`} onClick={() => setShowOngoing(true)}>Ongoing Projects</button>
                <button className={`projects-button ${!showOngoing ? 'active' : ''}`} onClick={() => setShowOngoing(false)}>Completed Projects</button>
            </div>

            <div className="ongoing-projects-container">
                <ul className="project">{arrayOfProjectsData}</ul>
            </div>

            <div className="all-projects-button-container">
                <button className="view-all-projects">View All Ongoing Prjects</button>
            </div>


        <div className="case-study-main-container">
            <h1 className="case-study-main-heading">Case Study Highlights</h1>

            <div className="case-study-cards-section">
                <div className="case-study-card">
                    <div className="case-study-image-section">
                        <img src={caseStudy1} alt="case-study-image" className="case-study-image" />
                    </div>
                    <div className="case-study-content-container">
                        <h1 className="case-study-heading">Riyadh Metro Project (Line 6 Stations)</h1>
                        <p className="case-study-description">Enabled one of KSA's largest transportation projects. <br />
                        Delivered with high precision and on schedule.</p>
                    </div>
                </div>

                <div className="case-study-card">
                    <div className="case-study-image-section">
                        <img src={caseStudy2} alt="case-study-image" className="case-study-image" />
                    </div>
                    <div className="case-study-content-container">
                        <h1 className="case-study-heading">NEOM Sindalah Island</h1>
                        <p className="case-study-description">Supported futuristic giga-project standards. <br />
                        Sustainable and innovative approach.</p>
                    </div>
                </div>

                <div className="case-study-card">
                    <div className="case-study-image-section">
                        <img src={caseStudy3} alt="case-study-image" className="case-study-image" />
                    </div>
                    <div className="case-study-content-container">
                        <h1 className="case-study-heading">Fadhili Gas Plant Pipeline</h1>
                        <p className="case-study-description">Critical role in Saudi energy infrastructure. <br />
                        Executed safely under Aramco's strict standards.</p>
                    </div>
                </div>

            </div>

            <div className="gradient-div-trusted" style={{color:"#000"}}>
            <h3 style={{color:'#fff',marginTop:'3%',textAlign:'center'}}>Trusted by Leading Companies</h3>
            <p style={{color:'#fff' , textAlign:"center"}}>Serving Saudi Arabia's most prestigious organizations for over 20 years</p>


          <div className="auto-logo-wrapper">
            <div className="logos-scroll">
              <div className="logos-group">
                {tustedLogos.map((logo, idx) => (
                  <img key={`logo-${idx}`} src={logo} alt={`logo-${idx}`} className="logo-img" />
                ))}
              </div>
            </div>
          </div>  
          </div>
        </div>


        </>
    )
}

export default Projects